import { container } from './container';
import {
  proxyMethod,
  actionInterceptor,
  generateIdProxy,
  staticIdProxy,
  generateIdDecorator,
  staticIdDecorator,
  HandlerInterceptor
} from './action.interceptor';
import { USER_OPERATION_SYNC_INTERCEPTOR_IDENTIFIER, SYNC_CONTEXT_SOURCE, CONTEXT_SOURCE } from './const';
/**
 * 生成操作前动作
 * @param {string} instanceName 
 * @param {string} methodName 
 * @returns 
 */
function generateActionBeforeFn (methodName) {
  return function (id, args) {
    let interceptor = container.get(USER_OPERATION_SYNC_INTERCEPTOR_IDENTIFIER);
    if (interceptor) {
      interceptor.preHandle(id, methodName, args);
    }
  };
}
/**
 * 生成操作后动作
 * @param {string} instanceName 
 * @param {string} methodName 
 * @returns 
 */
function generateActionAfterFn (methodName) {
  return function (id, args, result) {
    let interceptor = container.get(USER_OPERATION_SYNC_INTERCEPTOR_IDENTIFIER);
    if (interceptor) {
      interceptor.postHandle(id, methodName, args, result);
    }
  };
}
/**
 * 普通方法用户动作代理
 * @param {*} instanceName 
 * @param {*} methodName 
 * @param {*} fn 
 * @returns 
 */
function actionProxy (methodName, fn) {
  return proxyMethod(fn, generateActionBeforeFn(methodName), generateActionAfterFn(methodName));
}
/**
 * 类方法用户动作拦截
 * @param {*} opts 
 * @returns 
 */
function userActionInterceptor (opts) {
  return actionInterceptor(generateActionBeforeFn, generateActionAfterFn)(opts);
}
/**
 * 用户操作拦截处理器
 */
class UserOperationSyncInterceptor extends HandlerInterceptor {
  constructor (tranxceiver) {
    super(USER_OPERATION_SYNC_INTERCEPTOR_IDENTIFIER);
    this.tranxceiver = tranxceiver;
  }
  preHandle (id, methodName, args) {
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    const contextSource = syncContext.getContextSource();
    if (contextSource === CONTEXT_SOURCE.LOCAL) {
      this.tranxceiver.send(id, methodName, args);
    }
    return true;
  }
  postHandle () {
    return;
  }
}

export {
  staticIdProxy,
  generateIdProxy,
  staticIdDecorator,
  generateIdDecorator,
  actionProxy,
  userActionInterceptor,
  UserOperationSyncInterceptor
};